import { CompetitorComparison } from '@/components/CompetitorComparison';
import { useSEO } from '@/hooks/useSEO';

export default function SalsifyComparison() {
  useSEO({
    title: 'Ommni vs Salsify - Commerce Platform Comparison',
    description: 'Compare Ommni and Salsify. Ommni offers product + inventory control, cost-effective pricing, and faster deployment vs Salsify\'s enterprise-heavy platform.',
    keywords: 'ommni vs salsify, salsify alternative, commerce platform comparison, PIM syndication',
    canonical: 'https://ommni.io/competitors/salsify',
  });

  return (
    <CompetitorComparison
      title="Ommni vs Salsify"
      competitorName="Salsify"
      competitorUrl="https://www.salsify.com/"
      whyOmmni={[
        "Built for Product + Inventory: Ommni doesn't just manage <a href='/features/pim'>PIM</a> and syndication — it gives you control over <a href='/features/offers'>price</a>, availability, and <a href='/features/inventory'>stock thresholds</a> across your network.",
        "Retailer First: Where Salsify is designed for brands selling into retailers, Ommni is designed for retailers and DTC brands managing multiple channels, SKUs, and store locations.",
        "Simple, Flexible Implementation: Ommni's guided onboarding is faster and less resource-intensive than Salsify's enterprise-heavy setup.",
        "No Bloat: Ommni focuses on what's essential for omnichannel success: structured product data, real-time availability, and seamless <a href='/integrations'>integration</a> with your tech stack."
      ]}
      comparisonTable={[
        { feature: "Retailer/DTC Focus", ommni: true, competitor: false },
        { feature: "Inventory + Price Control", ommni: true, competitor: false, link: "/features/inventory" },
        { feature: "Ease of Implementation", ommni: true, competitor: false },
        { feature: "Workflow Engine", ommni: true, competitor: false, link: "/features/ommni-flow" },
        { feature: "Real-Time Data Sync", ommni: true, competitor: true }
      ]}
    />
  );
}
